import Styled from 'styled-components';

const LoaderContainer = Styled.div`
  width: 100%;
  text-align: center;
  ${({ headerHeight }) => `margin-top: calc((100vh - ${headerHeight}) / 2);`}
`;

export { LoaderContainer };
